export default __webpack_public_path__ + "static/media/martinize_cg.cbb3eb74.png";